export function removeCommas(formattedNumber) {
    return formattedNumber.replace(/,/g, "");
}

export function formatNumberWithCommas(number) {
    // Check if the number is not null, undefined, or NaN
    if (number === undefined || number === null || isNaN(number)) {
        return '';
    }
    // Convert number to string and use regular expression to add commas
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
